// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1db76","colMin":"styles_colMin__2Y5BV"};